module.exports = __webpack_public_path__ + "img/48-r.6f475edc.png";